export function coerceToString(value) {
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }
    if (value === null || value === undefined) {
        return '';
    }
    throw new Error(`Cannot coerce ${typeof value} to string`);
}
export function coerceToNumber(value) {
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        const parsed = Number.parseFloat(value);
        if (!Number.isNaN(parsed)) {
            return parsed;
        }
    }
    else if (typeof value === 'boolean') {
        return value ? 1 : 0;
    }
    throw new Error(`Cannot convert "${value}" to number`);
}
export function coerceToInteger(value) {
    const num = coerceToNumber(value);
    return Math.round(num);
}
export function coerceToBoolean(value) {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        const lower = value.toLowerCase().trim();
        if (lower === 'true' || lower === '1' || lower === 'yes') {
            return true;
        }
        if (lower === 'false' || lower === '0' || lower === 'no' || lower === '') {
            return false;
        }
        throw new Error(`Cannot convert "${value}" to boolean`);
    }
    if (typeof value === 'number') {
        return value !== 0;
    }
    throw new Error(`Cannot coerce ${typeof value} to boolean`);
}
